import React, { useContext } from 'react'
import styles from '../../ResumenADN.module.css'
import * as Funciones from "../../../../utils/funciones";
import * as Constantes from "../../../../utils/constantes";
import GeneralContext from '../../../../context/GeneralContext';

const TableCotizacion = ({
  cotizaciones,
  selectedsRows,
  onSelectRow,
  tipoGrupo
}) => {

  const { state: generalState } = useContext(GeneralContext)

  function comaMiles (cadena, separador) {
    let arrayCadena = cadena.split(separador) 
    let nuevo = ''
    for (let i = 0; i < arrayCadena.length; i++) {
      nuevo = nuevo.concat((arrayCadena[i].substr(-20, 1) === '$' ? '$ ' : 'S/ ') + 
        parseInt(arrayCadena[i].substr(-20, 1) === '$'
          ? arrayCadena[i].slice(2)
          : arrayCadena[i].slice(3)).toLocaleString('en-US', {minimumFractionDigits: 0}) + ' + ')
    }
    return nuevo.slice(0, -3)
  }

  return (
    <div className={styles.wrapCustomTable}>
      <div className={`${styles.wrapCustomTable__head} ${styles['wrapCustomTable__head_' + tipoGrupo]}`}>
        <div className={`${styles.field_nro} ${styles.wrapCustomTable__head__col}`}>
          Nro.
        </div>
        {tipoGrupo === Constantes.TIPO_COTIZACIONES_VENDIDAS
          ? <div className={`${styles.field_nro_sol} ${styles.wrapCustomTable__head__col}`}>
            Nro. Solicitud
          </div>
          : null
        }
        <div className={`${styles.field_fec_cotizacion} ${styles.wrapCustomTable__head__col}`}>
          {tipoGrupo === Constantes.TIPO_COTIZACIONES_VENDIDAS
            ? 'Fecha de venta'
            : 'Fecha de cotización'
          }
        </div>
        {tipoGrupo !== Constantes.TIPO_COTIZACIONES_VENDIDAS
          ? <div className={`${styles.field_fec_vencimiento} ${styles.wrapCustomTable__head__col}`}>
            Fecha de vencimiento
          </div>
          : null
        }
        <div className={`${styles.field_productos} ${styles.wrapCustomTable__head__col}`}>
          Productos
        </div>
        <div className={`${styles.field_sum_asegurada} ${styles.wrapCustomTable__head__col}`}>
          Suma Asegurada
        </div>
        <div className={`${styles.field_prima} ${styles.wrapCustomTable__head__col}`}>
          Prima
        </div>
        {tipoGrupo !== Constantes.TIPO_COTIZACIONES_VENCIDAS
          ? <div className={`${styles.field_estado} ${styles.wrapCustomTable__head__col}`}>
            {tipoGrupo === Constantes.TIPO_COTIZACIONES_VENDIDAS
              ? 'Estado Firma'
              : 'Estado Solicitud'
            }
          </div>
          : null
        }
      </div>

      {cotizaciones.map((cotizacion, i) => (
        <div
          key={i}
          className={`${styles.wrapCustomTable__body__row} ${styles['wrapCustomTable__body__row_' + tipoGrupo]}`}
          onClick={onSelectRow !== undefined ? (() => onSelectRow(cotizacion.codigoCotizacion)) : undefined}
          style={selectedsRows.toString() === cotizacion.codigoCotizacion.toString() ? { border: '1px solid #47A7DF' } : {}}
        >
          <div className={`${styles.field_nro} ${styles.wrapCustomTable__body__col}`}>
            {(i+1).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})}
          </div>
          {tipoGrupo === Constantes.TIPO_COTIZACIONES_VENDIDAS
            ? <div className={`${styles.field_nro_sol} ${styles.wrapCustomTable__body__col}`}
              style={cotizacion.solicitudeNumber !== null && cotizacion.solicitudeNumber.length > 1 ? {display: 'block'} : null}>
                {cotizacion.solicitudeNumber !== undefined && cotizacion.solicitudeNumber !== null && cotizacion.solicitudeNumber !== ''
                  ? cotizacion.solicitudeNumber.map((solic, indice) => (
                    <div
                      key={'solic_' + indice}
                      className={styles.texto_solicitud}
                      style={{height: (100/cotizacion.solicitudeNumber.length + '%')}}>
                        {solic}
                    </div>
                  ))
                : '-'}
            </div>
            : null
          }
          <div className={`${styles.field_fec_cotizacion} ${styles.wrapCustomTable__body__col}`}>
            {tipoGrupo === Constantes.TIPO_COTIZACIONES_VENDIDAS
              ? Funciones.transformarStringFechaToFormato(cotizacion.fechaVenta, Constantes.FORMATO_FECHA_1)
              : Funciones.transformarStringFechaToFormato(cotizacion.fechaCotizacion, Constantes.FORMATO_FECHA_1)
            }
          </div>
          {tipoGrupo !== Constantes.TIPO_COTIZACIONES_VENDIDAS
            ? <div className={`${styles.field_fec_vencimiento} ${styles.wrapCustomTable__body__col}`}>
              {Funciones.transformarStringFechaToFormato(cotizacion.fechaVencimiento, Constantes.FORMATO_FECHA_1)}
            </div>
            : null
          }
          <div
            className={`${styles.field_productos} ${styles.wrapCustomTable__body__col}`}
            style={cotizacion.descripcionCombinatoriaProductos !== null && cotizacion.descripcionCombinatoriaProductos.split(' + ').length > 1 ? {display: 'block'} : null}>
              {cotizacion.descripcionCombinatoriaProductos !== undefined && cotizacion.descripcionCombinatoriaProductos !== null
                ? cotizacion.descripcionCombinatoriaProductos.split(' + ').map((producto, indice) =>(
                  <div
                    key={'producto_' + indice}
                    style={{height: (100/cotizacion.descripcionCombinatoriaProductos.split(' + ').length + '%')}}
                    className={styles.texto_producto}>
                        {producto.toString().toUpperCase()}
                  </div>
                ))
                : null
              }
          </div>
          <div
            className={`${styles.field_sum_asegurada} ${styles.wrapCustomTable__body__col}`}
            style={cotizacion.sumaAsegurada !== null && cotizacion.sumaAsegurada.split(' + ').length > 1 ? {display: 'block'} : null}>
              {cotizacion.sumaAsegurada !== undefined && cotizacion.sumaAsegurada !== null && cotizacion.sumaAsegurada !== ''
                ? cotizacion.sumaAsegurada.split(' + ').map((sumAseg, indice) => (
                  <div
                    key={'sum_aseg_' + indice}
                    className={styles.texto_suma_asegurada}
                    style={{height: (100/cotizacion.sumaAsegurada.split(' + ').length + '%')}}>
                      {comaMiles(sumAseg, ' + ')}
                  </div>
                ))
                : '-'}
          </div>
          <div
            className={`${styles.field_prima} ${styles.wrapCustomTable__body__col}`}
            style={cotizacion.prima !== null && cotizacion.prima.split(' + ').length > 1 ? {display: 'block'} : null}>
              {cotizacion.prima !== undefined && cotizacion.prima !== null && cotizacion.prima !== ''
                ? cotizacion.prima.split(' + ').map((prim, indice) => (
                  <div
                    key={'prima_' + indice}
                    className={styles.texto_prima}
                    style={{height: (100/cotizacion.prima.split(' + ').length + '%')}}>
                      {prim}
                  </div>
                ))
              : '-'}
          </div>
          {tipoGrupo !== Constantes.TIPO_COTIZACIONES_VENCIDAS
            ? <div className={`${styles.field_estado} ${styles.wrapCustomTable__body__col}`}>
              {tipoGrupo === Constantes.TIPO_COTIZACIONES_VENDIDAS
                ? <label style={cotizacion.estadoFirma === '6' ? {fontWeight: 'bold'} : null}>
                    {(Funciones.obtenerValorTablaMaestra(generalState.tablasMaestras, Constantes.COD_TABLA_MAESTRA_ESTADO_FIRMA_SOLICITUD, cotizacion.estadoFirma))}
                  </label>
                : (cotizacion.codigoEstado === 1 ? 'Solicitud iniciada' : '')
              }
            </div>
            : null
          }
        </div>
      ))}
    </div>
  )
}

export default TableCotizacion
